/**
 * SitePick front — 共通 aria-live リージョン（docs/06 §16 / a11y）
 *
 * お気に入り / 比較の操作結果をスクリーンリーダーへ伝える。
 * `alert()` は使わない。1 ページに 1 つだけ生成する。
 */

let region = null;

/**
 * リージョンを用意する（無ければ body 末尾に作る）。
 *
 * @returns {HTMLElement|null}
 */
export function initLiveRegion() {
  if (region && document.body.contains(region)) {
    return region;
  }
  const existing = document.querySelector("[data-sp-live-region]");
  if (existing instanceof HTMLElement) {
    region = existing;
    return region;
  }
  if (!document.body) {
    return null;
  }
  region = document.createElement("div");
  region.setAttribute("data-sp-live-region", "");
  region.setAttribute("aria-live", "polite");
  region.setAttribute("aria-atomic", "true");
  region.className = "c-live-region u-visually-hidden";
  document.body.appendChild(region);
  return region;
}

/**
 * メッセージを読み上げさせる。
 *
 * @param {string} message
 * @returns {void}
 */
export function announce(message) {
  const el = initLiveRegion();
  if (!el || !message) {
    return;
  }
  // 同じ文字列でも再通知されるよう一度空にする。
  el.textContent = "";
  window.requestAnimationFrame(() => {
    el.textContent = String(message);
  });
}
